import {useState} from 'react'

const RadioButton = ({
    label,
    field,
    isRequired = true,
    isCheked,
    onChange
}: IPropsRadioButton) => {

    const on = ( e : any) => {
        const chk = e.target.value === 'S'?  true: false;
        onChange(e.target.name, chk);
    }

    return (
        <>
            <div className='mt-10 mb-5 lbl-input-cvs-radio'>
                {label}
            </div>
            <div >
                <div className='radio-cvs'>
                    <input type='radio' name={field} value={'S'} id={`S_${field}`} checked={isCheked === true} onChange={on} required={isRequired} />
                    <label className='lbl-input-cvs-radio2' htmlFor={`S_${field}`}>Si</label>
                </div>
                <div className='radio-cvs'>
                    <input type='radio' name={field} value={'N'} id={`N_${field}`} checked={isCheked === false} onChange={on} required={isRequired} />
                    <label className='lbl-input-cvs-radio2' htmlFor={`N_${field}`}>No</label>
                </div>
              
            </div>
        </>
    );

}

export { RadioButton };